import * as types from './types';

const initialState = {
  open: false,
  message: '',
  autoHideDuration: 1200,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

const openSnackbar = (state, message) => {
  return {
    ...state,
    message,
    open: true,
  };
};

const closeSnackbar = state => ({
  ...state,
  open: false,
});

export default(state = initialState, action) => {
  switch (action.type) {
    case types.OPEN_SNACKBAR:
      return openSnackbar(state, action.payload);
    case types.CLOSE_SNACKBAR:
      return closeSnackbar(state);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/snackbar/index.js